import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-3010">
      <div className="dark" data-id="element-3011">
        <Hero data-id="element-3012" />
      </div>
      <WhyUs data-id="element-3013" />
      <ByTheNumbers data-id="element-3014" />
      <Services data-id="element-3015" />
      <FAQ data-id="element-3016" />
      <Reviews data-id="element-3017" />
      <CtaBanner data-id="element-3018" />
    </main>;
}